<script setup>
import { ref, watch } from 'vue'
import Checkbox from '@/Shared/Components/Forms/Checkbox.vue'

const emit = defineEmits(['checkedValuesChanged'])

const props = defineProps({
  checked: {
    type: [Array, Object],
    default: () => [],
  },
  optionList: Array,
  allInOneRow: {
    type: Boolean,
    default: true,
  },
})

const checkedValues = ref(props.checked)

watch(checkedValues, () => {
  emit('checkedValuesChanged', checkedValues)
})
</script>

<template>
  <div
    id="checkbox_option"
    :class="
      allInOneRow
        ? 'grid md:flex md:gap-x-4 grid-cols-2 items-center'
        : 'grid grid-cols-1 md:grid-cols-5 gap-4 items-center'
    "
  >
    <div
      v-for="option in props.optionList"
      :key="option.id"
      class="flex items-center md:mt-0 mt-4"
    >
      <!-- Checkbox -->
      <Checkbox
        v-model:checked="checkedValues"
        v-model:value="option.id"
      />
      <div v-if="option.src">
        <img
          :src="option.src"
          class="p-2"
        />
      </div>
      <!-- Label -->
      <span
        class="text-black"
        :class="allInOneRow ? 'ml-2' : ''"
      >
        {{ option.title }}
      </span>
    </div>
  </div>
</template>
